import React, { useEffect } from 'react';

const CIFValue = ({ formData, setFormData, readOnly }) => {

    const handleCheckboxChange = () => {
        const originalValue = parseFloat(formData.cargoValue.value || 0);
        const cifPersenatge = originalValue * 1.1;

        setFormData((prevFormData) => ({
            ...prevFormData,
            cifValue: {
                ...prevFormData.cifValue,
                value: cifPersenatge.toFixed(2)
            }
        }));
    };

    useEffect(() => {
        handleCheckboxChange();
    }, [formData.cargoValue]);

    return (
        <div className="flex items-center gap-3 w-full">
            <input
                type="text"
                id='cifValue'
                readOnly={readOnly}
                disabled={readOnly}
                className={`w-full h-8 p-2 text-sm border rounded-md outline-none 
                    ${readOnly ? "bg-gray-100 cursor-not-allowed" : ""}`}
                value={formData.cifValue.value || ''}
            />
        </div>
    );
};

export default CIFValue;
